/**
 * @file components/biz/common/drawerAction.js
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import _ from 'lodash';

import {createPayload} from '../../common/helper';
import {DrawerOption} from '../index';

export function drawerAction(drawerOption: DrawerOption, payload: any) {
    const {className, width, title, maskClosable, body, foot, mask} = drawerOption;
    const {cancelWithSuccess, okText, cancelText, fromTable = false} = drawerOption;
    const $title = _.template(title)(payload);

    const {$payloadFields, $extraPayload, content, $onBeforeOpen} = body;
    payload = createPayload(payload, $payloadFields, $extraPayload);
    // 打开前修改数据钩子
    payload = typeof $onBeforeOpen === 'function'
        ? ($onBeforeOpen(payload) || payload) : payload;

    const drawerParams = {
        className,
        title: $title,
        width,
        maskClosable,
        foot,
        okText,
        cancelText,
        cancelWithSuccess,
        payload,
        wrappedComponent: content,
        fromTable,
        mask
    };
    return drawerParams;
}
